// Property for associating elevation features into regular features
export const PROPERTY_ELEVATION_ID = '3d_elevation_id';

// Hard coded source layer name for HD road elevation data.
export const HD_ELEVATION_SOURCE_LAYER = 'hd_road_elevation';

export const MARKUP_ELEVATION_BIAS = 0.05;
